import { Controller } from "@hotwired/stimulus"

// Sizes an iframe to its document so the whole thing shows with no inner
// scrollbar. Needs `sandbox="allow-same-origin"` (or no sandbox) on the
// iframe: a fully sandboxed frame has an opaque origin and hides its
// contentDocument from the page.
//
// The height is measured on `load` (wire `load->iframe-fit#fit`) and whenever
// the iframe's own box changes: a hidden tab has no layout, so a frame that
// loaded inside one measures 0 until the tab shows; a window resize reflows
// the text; a Turbo stream replacing the frame connects a fresh one.
//
// Used by the texts page preview (school_texts/_preview).
export default class extends Controller {
  connect() {
    this.observer = new ResizeObserver(() => this.fit())
    this.observer.observe(this.element)
  }

  disconnect() {
    this.observer.disconnect()
  }

  fit() {
    const documentElement = this.element.contentDocument?.documentElement
    if (!documentElement) return

    // Written on the next frame so the observer does not see its own change
    // in the same layout pass and log "loop completed with undelivered
    // notifications".
    requestAnimationFrame(() => {
      // The mail layout sets `html, body { height: 100% }`, so scrollHeight
      // never reports less than the frame's current height: collapse first,
      // then measure. Nothing paints between the two writes.
      this.element.style.height = "0px"
      this.element.style.height = `${documentElement.scrollHeight}px`
    })
  }
}
